module.exports = __webpack_public_path__ + "static/media/feather-webfont.b8e9cbc7.ttf";